import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonUtilitiesService } from '../common-utilities.service';
import { Subscription } from 'rxjs';
import { MessageService } from './modal-info.service';
import { constants } from '../constants';
import { Router } from '@angular/router';


@Component({
  selector: 'app-modal-info',
  templateUrl: './modal-info.component.html',
  styleUrls: ['./modal-info.component.scss']
})
export class ModalInfoComponent implements OnInit {

  messages: any[] = [];
  subscription: Subscription;

  actual:string = ""
  new:string = ""
  currentCombo = null
  recurrent:boolean = false
  infoRecurrentExist:any
  questionRecurrent:boolean = true
  isLoadingBalance = false

  @Input('isShowModal') isShowModal:boolean = false;
  @Input('isChangeNumberBtn') isChangeNumberBtn:boolean = false;
  @Input('isChangeChipBtn') isChangeChipBtn:boolean = false;
  @Input('isComboRecurrentActive') isComboRecurrentActive:boolean = false;
  @Input('langTextRequestSent') langTextRequestSent:boolean = false;
  @Input('modalTitle') modalTitle:string = '';
  @Input('modalContent') modalContent:string = '';
  @Output() hiddenModal = new EventEmitter();;

  constructor(
    private messageService: MessageService,
    private _router: Router,
    public LANG: CommonUtilitiesService
    ) { 
      /**
      * Description: Evento que se encarga de recibir los parametros 
      * cuando es una compra recurrente o cuando es unica para 
      * cambiar estado y presentar el modal segun necesidad del usuario
      * Autor: Luis Fernando Hernandez
      * @param 
      * @return 
      */
      this.subscription = this.messageService.getMessage().subscribe(message => {
        
        if (message) {
          if(message.text == this.LANG.getLangText('VALID_RECURRENT_TYPE')){
            this.currentCombo = JSON.parse(localStorage.getItem("shoppingCart"));
            // let bonuses = this.currentCombo['bonuses']
            this.actual = message.text2.subcriptionProduct.productName
            this.infoRecurrentExist = message.text2
            // this.new = bonuses[0].commercialDescription
            if (this.currentCombo.bonuses == null || typeof this.currentCombo.bonuses === 'undefined') {
              this.new = this.currentCombo.commercialDescription;
            } else {
              for (let k in this.currentCombo.bonuses) {
                if (this.currentCombo.bonuses[k].isMain == 'S') {
                  this.new = this.currentCombo.bonuses[k].commercialDescription;
                  break;
                }
              }
            }

            this.recurrent = true
          }else{
            this.recurrent = false
          }
        }
      });
  }

  ngOnInit() {
  }

  /**
  * Description: Funcion que se encarga de actualizar el subscribe 
  * cuando es una compra unica y de esta manera no mostrar modal
  * con info de compra recurrente existente 
  * Autor: Luis Fernando Hernandez
  * @param 
  * @return 
  */
  onlyView(){
    this.messageService.viewOnlyEvent(this.LANG.getLangText('ONLY_ACTIVATE'));
  }

  /**
  * Description: Metodo que se encarga de realizar el reemplazo del combo recurrente actual por el nuevo
  * Autor: Luis Fernando Hernandez
  * @param 
  * @return 
  */
  replaceRecurrent(){

    this.isLoadingBalance = true;
    let jsonReplaceRecurrent = {
      "codeSuscription":this.infoRecurrentExist.codeSuscription,
      "initialDate":this.getDateInfo(),
      "product":{
        "referenceCode":this.currentCombo.idPaymentManager,
        "description":this.infoRecurrentExist.subcriptionProduct.serviceDescription
      }
    }

    this.messageService.replaceRecurrent(jsonReplaceRecurrent).subscribe((valData => {
        this.isLoadingBalance = false;
        if (valData['responseCode'] == constants.SUCCESS_WS_RESPONSE_CODE) {
          this.viewReplaceRecurrent()
        }else{
          this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
          this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
          this.isShowModal = true;
          return;
        }
    }),
    (err) => {
      this.isLoadingBalance = false;
      this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
      this.modalContent = this.LANG.getLangText('LABEL_ERROR_SERVICE_CONN');
      this.isShowModal = true;
      return;
    });

  }

  /**
  * Description: Metodo que retorna el formato 
  * fecha segun como pide el servicio de reemplazo de compra recurrente
  * Autor: Luis Fernando Hernandez
  * @param 
  * @return 
  */
  getDateInfo() {
    let now = new Date();
    let year = "" + now.getFullYear();
    let month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
    let day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
    let hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
    let minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
    let second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
    return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
  }

  /**
  * Description: Metodo que se encarga mostrar salida de reemplazo de compra recurrente
  * Autor: Luis Fernando Hernandez
  * @param 
  * @return 
  */
  viewReplaceRecurrent(){
    this.questionRecurrent = false
    setTimeout(() => {
      this._router.navigate([constants.ROUTE_URL_MY_ACCOUNT]) 
    }, 5000);    
  }


  hideModal(){
    this.questionRecurrent = true
    this.hiddenModal.emit();
  }
  
  showPrimaryBtn(){
    return (!this.isChangeNumberBtn && !this.isChangeChipBtn);
  }
}
